import {
	IconBrandDiscord,
	IconBrandInstagram,
	IconBrandLinkedin,
	IconBrandX,
} from "@tabler/icons-react";
import { FC } from "react";

const Footer: FC = () => {
	return (
		<div
			className="text-left overflow-hidden text-[#FFFFFFB2] snap-end snap-always w-full h-[26.5rem] md:h-[31.25rem] xl:min-h-[80vh] xl:max-h-[80vh] bg-[url(/landingpage/footerBg.png)] bg-cover bg-center px-7 md:px-8 xl:px-20 pt-9 md:pt-[97px] xl:pt-20 flex flex-col"
			style={{ position: "relative" }}
		>
			<div className="h-[15.75rem] md:h-[12.875rem] xl:h-[40vh] flex flex-col justify-between pb-6 border-b border-[#FFFFFF9C] relative z-[60]">
				<div className="flex flex-col-reverse gap-7 md:flex-row items-left w-full md:justify-between md:items-center">
					<div className="flex flex-col md:flex-row gap-6 text-xs md:text-title1 leading-none font-medium">
						<a
							href="/contact"
							className="cursor-pointer hover:text-white transition-colors duration-200"
						>
							<p>Contact us</p>
						</a>
						<a
							href="/terms"
							className="cursor-pointer hover:text-white transition-colors duration-200"
						>
							<p>Terms of service</p>
						</a>
					</div>
					<div className="flex flex-row gap-6 text-title1 leading-none font-medium">
						{/* <a><IconBrandDiscord className="md:w-8 w-7 aspect-square" /></a> */}
						<a
							href="https://www.linkedin.com/company/curohq"
							target="_blank"
							rel="noopener noreferrer"
							className="cursor-pointer hover:text-white transition-colors duration-200 relative z-[70] block"
						>
							<IconBrandLinkedin className="md:w-8 w-7 aspect-square" />
						</a>
						<a
							href="https://www.instagram.com/curohq/"
							target="_blank"
							rel="noopener noreferrer"
							className="cursor-pointer hover:text-white transition-colors duration-200 relative z-[70] block"
						>
							<IconBrandInstagram className="md:w-8 w-7 aspect-square" />
						</a>
						<a
							href="https://x.com/curohq"
							target="_blank"
							rel="noopener noreferrer"
							className="cursor-pointer hover:text-white transition-colors duration-200 relative z-[70] block"
						>
							<IconBrandX className="md:w-8 w-7 aspect-square" />
						</a>
					</div>
				</div>
				<div className="text-xs md:text-base leading-none font-normal flex flex-col gap-2">
					<p>Copyright ©2025 Pixelpath Studio Pvt. Ltd.</p>
					<p>All rights reserved.</p>
				</div>
			</div>

			<img
				className="absolute bottom-0 right-1/2 translate-x-1/2 z-50"
				src="/landingpage/footerlogo.svg"
				style={{ width: "800px !important" }}
			></img>
		</div>
	);
};

export default Footer;
